import {
    MarketAllowance,
    OutcomeAllowance,
    SelectedOutcome,
    SpecifierPair,
} from '../types';
import { createAllowancesKey } from '../utils';

export function isMarketSpecifersPairValid(
    outcome1: SelectedOutcome,
    outcome2: SelectedOutcome,
    allowedMarketCombinations?: Record<string, Set<MarketAllowance>>,
    allowedCoutcomeCombinations?: Record<string, Set<OutcomeAllowance>>,
): boolean {
    let specifiersEqual: SpecifierPair[] = [];
    let specifiersNotEqual: SpecifierPair[] = [];

    const marketCombinationKey = createAllowancesKey(outcome1.marketId, outcome2.marketId);
    const outcomeCombinationKey = createAllowancesKey(outcome1.outcomeId, outcome2.outcomeId);

    if (allowedMarketCombinations && marketCombinationKey in allowedMarketCombinations) {
        const marketAllowances = allowedMarketCombinations[marketCombinationKey];
        specifiersEqual = Array.from(marketAllowances).flatMap((allowance) => allowance.specifiersEqual ?? []);
        specifiersNotEqual = Array.from(marketAllowances).flatMap((allowance) => allowance.specifiersNotEqual ?? []);
    } else if (allowedCoutcomeCombinations && outcomeCombinationKey in allowedCoutcomeCombinations) {
        const outcomeAllowances = allowedCoutcomeCombinations[outcomeCombinationKey];
        specifiersEqual = Array.from(outcomeAllowances).flatMap((allowance) => allowance.specifiersEqual ?? []);
        specifiersNotEqual = Array.from(outcomeAllowances).flatMap((allowance) => allowance.specifiersNotEqual ?? []);
    } else {
        return true;
    }

    return validateSpecifiers(specifiersEqual, outcome1, outcome2, true) && validateSpecifiers(specifiersNotEqual, outcome1, outcome2, false);
}

export function validateSpecifiers(
    specifierPairs: SpecifierPair[],
    outcome1: SelectedOutcome,
    outcome2: SelectedOutcome,
    shouldEqual: boolean,
): boolean {
    if (specifierPairs.length === 0) {
        return true;
    }

    for (const specifierPair of specifierPairs) {
        const value1 = outcome1.specifiers?.[specifierPair.specifier1] ?? null;
        const value2 = outcome2.specifiers?.[specifierPair.specifier2] ?? null;

        if (value1 && value2) {
            const areEqual = value1 === value2;

            if (shouldEqual !== areEqual) {
                return false;
            }
        }
    }

    return true;
}
